import React from "react";
import PropTypes from "prop-types";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";

const { SITE_NAME } = process.env;

const StateBreadcrumbs = ({ state }) => (
	<Box pb={6} pt={6} bgcolor={"#FAFAFA"}>
		<Container maxWidth="md">
			<Breadcrumbs
				separator="//"
				aria-label="breadcrumb"
				color="textSecondary"
				style={{ fontSize: 14, lineHeight: "16px" }}
			>
				<Link color="inherit" href="/">
					{SITE_NAME.ucFirst()}
				</Link>
				<Link color="inherit" href={`${state.url}/`}>
					{state.name.ucFirst()}
				</Link>
			</Breadcrumbs>
		</Container>
	</Box>
);

StateBreadcrumbs.propTypes = {
	state: PropTypes.shape({
		name: PropTypes.string.isRequired,
		abbreviation: PropTypes.string.isRequired,
	}).isRequired,
};

export default StateBreadcrumbs;
